var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_22628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 15.7451L10.6406 15.0264C8.53906 13.8154 6.78906 12.0654 5.57812 9.96387L4.85938 8.71777L5.875 7.70215L7.17188 6.40527L5.70312 2.72559L1.87891 3.4209C2.04297 11.7998 8.80859 18.5615 17.1875 18.7295L17.8789 14.9053L14.1992 13.4326L12.9023 14.7295L11.8867 15.7451ZM13.75 11.2334L20 13.7334L18.75 20.6084H17.5C7.83594 20.6084 0 12.7725 0 3.1084V1.8584L6.875 0.608398L9.375 6.8584L7.20312 9.03027C8.25 10.8467 9.76172 12.3584 11.5781 13.4053L13.75 11.2334Z",
    fill: "#1A1818",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_22628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.608398)"
  })))));
};
export default SvgPhone;